<template>
    <CSidebar 
      fixed 
      :minimize="minimize"
      :show="show"
      @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
    >
      <CSidebarBrand class="d-md-down-none" to="/">
        <img src="../assets/img/status-up.png" :height="30" alt="Interviewrr.ai company status logo"/> 
        <label class="custom-20px-700 ml-2">Dashboard</label>
      </CSidebarBrand>
  
      <CRenderFunction flat :content-to-render="dynamicNav" />
      <div class="mt-auto"> <!-- Use mt-auto to push the content to the bottom -->
        <CButton class="mb-2" to="HowItWorkCompany"><img style="max-width:30px" src="../assets/img/Search.png" alt="Interviewrr.ai icon logout" class="mr-1"/>How It Works</CButton>
      <CButton class="mb-2" to="VideoPlaylist"><img style="max-width:30px" src="../assets/img/video-square.png" alt="Interviewrr.ai icon logout" class="mr-1"/>User Guide</CButton>
      <br />
      <CButton class="mb-2" to="Setting"><img style="max-width:30px" src="../assets/img/GearSix.png" alt="Interviewrr.ai icon logout" class="mr-1"/>Setting</CButton>
      <br />
      <CButton class="mb-2" v-on:click="SignOut()"><img style="max-width:30px" src="../assets/img/logout.png" alt="Interviewrr.ai icon logout" class="mr-1"/>Logout</CButton>
    </div>
      <!-- <CSidebarMinimizer
        class="d-md-down-none"
        @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
      /> -->
    </CSidebar>
  </template>
  
  <script>
  
  export default {
    name: 'TheSidebar',
    data() {
        return {
            features: [],
            dynamicNav: [],
            user: {}
        };
    },
    computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    }
  },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async getFeatures() {
            try {
                const response = await this.$API.get(this.$GetFeatures, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.features = response.data;
                    this.buildNav(this.features);
                } else {
                    console.error(`Unexpected response status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching features:', error);
            }
        },
        buildNav(features) {
            // Define the desired order for FeaturesType
            const featureOrder = [
                'Dashboard',
                'Ask_AI_Beta',
                'All_Candidate',
                'Your_List',
                'Selected_Candidate',
                'Input',
                'Share_QR',
                'All_Feature'
            ];

            // Sort features based on the predefined order
            const sortedFeatures = features.sort((a, b) => {
                const orderA = featureOrder.indexOf(a.FeaturesType);
                const orderB = featureOrder.indexOf(b.FeaturesType);
                return orderA - orderB; // Sort in ascending order
            });

            // Remove duplicates by FeaturesType
            const uniqueFeatures = sortedFeatures.filter((feature, index, self) =>
                index === self.findIndex(f => f.FeaturesType === feature.FeaturesType)
            );

            // Generate the sidebar structure
            this.dynamicNav = [
                {
                    _name: 'CSidebarNav',
                    _children: uniqueFeatures
                        .filter((feature) => feature.IsVisible)
                        .map((feature) => {
                            switch (feature.FeaturesType) {
                                case 'Dashboard':
                                    return {
                                        _name: 'CSidebarNavItem',
                                        name: 'Dashboard',
                                        to: 'Dashboard',
                                        icon: {
                                            src: require('@/assets/img/element-4.png'),
                                            width: 15,
                                            height: 15,
                                            class: 'mr-3',
                                        },
                                    };
                                case 'Ask_AI_Beta':
                                    return {
                                        _name: 'CSidebarNavItem',
                                        name: 'Ask AI (Beta)',
                                        to: '/AskAI',
                                        icon: {
                                            src: require('@/assets/img/askai.png'),
                                            width: 15,
                                            height: 15,
                                            class: 'mr-3',
                                        },
                                        class: 'sidebar-item-text',
                                    };
                                case 'All_Candidate':
                                    return {
                                        _name: 'CSidebarNavItem',
                                        name: 'All Candidates (Recruitment)',
                                        to: 'Recruitment',
                                        icon: {
                                            src: require('@/assets/img/profile-2user.png'),
                                            width: 15,
                                            height: 15,
                                            class: 'mr-3',
                                        },
                                    };
                                case 'Your_List':
                                    return {
                                        _name: 'CSidebarNavDropdown',
                                        name: 'Your List',
                                        icon: {
                                            src: require('@/assets/img/profile-2user.png'),
                                            width: 15,
                                            height: 15,
                                            class: 'mr-3',
                                        },
                                        items: [
                                            {
                                                name: 'Customer Feedback',
                                                to: '/VideoList',
                                                icon: {
                                                    src: require('@/assets/img/profile-2user.png'),
                                                    width: 15,
                                                    height: 15,
                                                    class: 'mr-3',
                                                },
                                            },
                                            {
                                                name: 'Job Seeker',
                                                to: '/InterviewCandidateList',
                                                icon: {
                                                    src: require('@/assets/img/video-square.png'),
                                                    width: 15,
                                                    height: 15,
                                                    class: 'mr-3',
                                                },
                                            },
                                        ],
                                    };
                                case 'Selected_Candidate':
                                    return {
                                        _name: 'CSidebarNavItem',
                                        name: 'Selected Candidate',
                                        to: 'ShortlistedCandidate',
                                        icon: {
                                            src: require('@/assets/img/user-tick.png'),
                                            width: 15,
                                            height: 15,
                                            class: 'mr-3',
                                        },
                                    };
                                case 'Input':
                                    return {
                                        _name: 'CSidebarNavDropdown',
                                        name: 'Management',
                                        icon: {
                                            src: require('@/assets/img/PlusThin.png'),
                                            width: 15,
                                            height: 15,
                                            class: 'mr-3',
                                        },
                                        items: [
                                            {
                                                name: 'Voucher',
                                                to: '/ManageVoucher',
                                                icon: {
                                                    src: require('@/assets/img/iconvoucher.png'),
                                                    width: 15,
                                                    height: 15,
                                                    class: 'mr-3',
                                                },
                                            },
                                            {
                                                name: 'Blog',
                                                to: '/ManageBlog',
                                                icon: {
                                                    src: require('@/assets/img/iconblog.png'),
                                                    width: 15,
                                                    height: 15,
                                                    class: 'mr-3',
                                                },
                                            },
                                            {
                                                name: 'Countries',
                                                to: '/ManageFlag',
                                                icon: {
                                                src: require('@/assets/img/quiz.png'),
                                                width: 15,
                                                height: 15,
                                                class: 'mr-3'
                                                },
                                            },
                                            {
                                                name: 'Contact Us',
                                                to: '/ManageContact',
                                                icon: {
                                                src: require('@/assets/img/iconcontact.png'),
                                                width: 15,
                                                height: 15,
                                                class: 'mr-3'
                                                },
                                            },
                                            {
                                                name: 'Question',
                                                to: '',
                                                icon: {
                                                src: require('@/assets/img/quiz.png'),
                                                width: 15,
                                                height: 15,
                                                class: 'mr-3'
                                                },
                                            },
                                            {
                                                name: 'Subscription',
                                                to: '/ManageSubscription',
                                                icon: {
                                                src: require('@/assets/img/subscribe.png'),
                                                width: 15,
                                                height: 15,
                                                class: 'mr-3'
                                                },
                                            },  
                                            {
                                                name: 'Generate Report',
                                                to: '/GenerateReport',
                                                icon: {
                                                src: require('@/assets/img/document-upload.png'),
                                                width: 15,
                                                height: 15,
                                                class: 'mr-3'
                                                },
                                            },
                                            {
                                                name: 'Applicant',
                                                to: '/ManageApplicant',
                                                icon: {
                                                src: require('@/assets/img/Document.png'),
                                                width: 15,
                                                height: 15,
                                                class: 'mr-3'
                                                },
                                            },
                                            {
                                                name: 'Counter Visitor',
                                                to: '/CounterVisitor',
                                                icon: {
                                                src: require('@/assets/img/Document.png'),
                                                width: 15,
                                                height: 15,
                                                class: 'mr-3'
                                                },
                                            },
                                            {
                                                name: 'Access Feature',
                                                to: '/ManageFeature',
                                                icon: {
                                                src: require('@/assets/img/Document.png'),
                                                width: 15,
                                                height: 15,
                                                class: 'mr-3'
                                                },
                                            },
                                            {
                                                name: 'Control Voucher',
                                                to: '/ManageVoucherCompany',
                                                icon: {
                                                src: require('@/assets/img/Document.png'),
                                                width: 15,
                                                height: 15,
                                                class: 'mr-3'
                                                },
                                            },

                                            // Add other sub-menu items here
                                        ],
                                    };
                                case 'Share_QR':
                                    return {
                                        _name: 'CSidebarNavDropdown',
                                        name: 'Share QR',
                                        icon: {
                                            src: require('@/assets/img/scan-barcode.png'),
                                            width: 15,
                                            height: 15,
                                            class: 'mr-3',
                                        },
                                        items: [
                                            {
                                                name: 'Customer Feedback',
                                                to: '/ManageQR',
                                                icon: {
                                                    src: require('@/assets/img/Document.png'),
                                                    width: 15,
                                                    height: 15,
                                                    class: 'mr-3',
                                                },
                                            },
                                            {
                                                name: 'Job Seeker',
                                                to: '/ManageQRJob',
                                                icon: {
                                                    src: require('@/assets/img/Document.png'),
                                                    width: 15,
                                                    height: 15,
                                                    class: 'mr-3',
                                                },
                                            },
                                        ],
                                    };
                               
                                default:
                                    return null; // Ignore unsupported features
                            }
                        })
                        .filter((item) => item !== null), // Filter out null items
                },
            ];

        }
    },
    created() {
        this.getFeatures();
        this.GetInfoUser();
    },
};
  </script>
<style scoped>
  .c-sidebar {
    background-color: #f7f7f7; /* Ensure white background */
}
  </style>